import React from "react";
import "./DriveClubPromo.css";

const DRIVE_CLUB_URL = "https://drive.wtm-sportwagen.com";

const DriveClubPromo = () => {
  return (
    <a
      href={DRIVE_CLUB_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="drive-club-banner"
      aria-label="WTM Drive Club — Termine ansehen und Platz reservieren"
    >
      <div className="drive-club-banner__headline">
        <div className="drive-club-banner__bars" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <span className="drive-club-banner__badge">Neu</span>
        <strong className="drive-club-banner__title">WTM Drive Club</strong>
      </div>

      <p className="drive-club-banner__message">
        Raus aus der Werkstatt. Rauf auf die Straße.
      </p>

      <span className="drive-club-banner__cta">
        Termine &amp; Anmeldung
        <span aria-hidden="true">→</span>
      </span>
    </a>
  );
};

export default DriveClubPromo;
